import { Building2, Settings, Users } from 'lucide-react'
import type { NavItem } from '@/components/templates/app-shell'

export const platformAdminNav: NavItem[] = [
  { label: 'Associations', icon: Building2, active: true, href: '/platform/associations' },
  { label: 'Admins', icon: Users },
  { label: 'Settings', icon: Settings },
]
